var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1707478292(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 59.9091V25H28.4205C31.0341 25 33.2898 25.5114 35.1875 26.5341C37.0966 27.5455 38.5682 28.9602 39.6023 30.7784C40.6364 32.5852 41.1534 34.6875 41.1534 37.0852C41.1534 39.4943 40.625 41.6023 39.5682 43.4091C38.5227 45.2045 37.0284 46.5966 35.0852 47.5852C33.142 48.5739 30.8352 49.0682 28.1648 49.0682H19.267V42.4205H26.5966C27.8693 42.4205 28.9318 42.1989 29.7841 41.7557C30.6477 41.3125 31.3011 40.6932 31.7443 39.8977C32.1875 39.0909 32.4091 38.1534 32.4091 37.0852C32.4091 36.0057 32.1875 35.0739 31.7443 34.2898C31.3011 33.4943 30.6477 32.8807 29.7841 32.4489C28.9205 32.017 27.858 31.8011 26.5966 31.8011H22.4375V59.9091H14Z",
    fill: "#21AA47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 59.9091V25H69.6534V31.8523H53.75V39.0114H68.4091V45.8807H53.75V53.0568H69.6534V59.9091H45.3125Z",
    fill: "#21AA47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 78,
    height: 78,
    rx: 7,
    stroke: "#21AA47",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1707478292);
export default __webpack_public_path__ + "static/media/Group 1707478292.061ad071e05ff21605d1f523cfb8b8fe.svg";
export { ForwardRef as ReactComponent };